var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission"},[_c('h2',[_vm._v("Access Denied")]),_c('p',[_vm._v("You don't have permission to access dashboard page.")])])
}]

export { render, staticRenderFns }